<div id="wrapper" *ngIf="userLoggedIn && !userUnauthorized">
  <draeger-navbar [permissions]="permissions"></draeger-navbar>
  <draeger-notification></draeger-notification>
</div>
